module.exports = __webpack_public_path__ + "img/ic_view.10958a17.svg";